import React from 'react';
import styled from 'styled-components';
import { sectionMargins } from '../styles';
import { Container, HtmlContent, SectionHeader } from './ui';
import ContentImageSlider from './ContentImageSlider';

const StyledContent = styled.section`
  ${({ $isCommunityStoryDetail }) =>
    $isCommunityStoryDetail
      ? sectionMargins(undefined, '80px')
      : sectionMargins('50px', '140px')};
  overflow: hidden;
`;

const Content = ({ heading, text, content, isCommunityStoryDetail }) => {
  const options = {
    renderNode: {
      'embedded-entry-block': node => {
        const { images, flip } = node.data.target;

        return <ContentImageSlider images={images} flip={flip} />;
      },
    },
  };

  return (
    <StyledContent $isCommunityStoryDetail={isCommunityStoryDetail}>
      <Container narrow={true}>
        {heading && <SectionHeader heading={heading} text={text} />}
        <HtmlContent content={content} options={options} />
      </Container>
    </StyledContent>
  );
};

export default Content;
